module.exports = __webpack_public_path__ + "static/media/email-warning.dcec2ef8.png";